import uesSpecialityCode from '../../../../transperfect/data/en/uesSpecialityTranslations.json';

export const isProviderVisionSpecialist = (specialties: string[]) => {
  for (const key in uesSpecialityCode) {
    const innerArray = uesSpecialityCode[key];
    for (const item of innerArray) {
      if (
        item?.description?.toLowerCase() == 'vision' &&
        specialties?.includes(item.category)
      ) {
        return true;
      }
    }
  }

  return false;
};
